import { LeaderboardTable } from "../components/sidekick/leaderboard/LeaderboardTable";
import {
  Card,
  EmptyState,
  ErrorState,
  LoadingState,
  Page,
  PageHeader,
} from "../components/ui";
import { useLeaderboard } from "../hooks/useLeaderboard";

function Leaderboard() {
  const { data, isLoading, isError, refetch } = useLeaderboard();

  let body;
  if (isLoading) {
    body = <LoadingState />;
  } else if (isError) {
    body = (
      <ErrorState onRetry={() => refetch()} retryLabel="Try again">
        Couldn't load the leaderboard.
      </ErrorState>
    );
  } else if (data.length === 0) {
    body = (
      <Card variant="panel">
        <EmptyState icon="insights" title="No leaderboard yet">
          People appear here once they have more than 10 minutes of summarised
          calls in the last 30 days.
        </EmptyState>
      </Card>
    );
  } else {
    body = <LeaderboardTable data={data} />;
  }

  return (
    <Page maxWidth={760}>
      <PageHeader
        title="Leaderboard"
        subtitle="Top 10 by average call sentiment over the last 30 days"
      />
      {body}
    </Page>
  );
}

export default Leaderboard;
